
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-ryerson/ryerson-commitment",
      function () {
        return require("private-next-pages/why-ryerson/ryerson-commitment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-ryerson/ryerson-commitment"])
      });
    }
  